<template>
	<div class="appr-container m-0 p-0" style="background-color: #000000;">
		<div class="container-fluid my-0" v-if="(isMobile && !isPortrait) || !isMobile">
			<div class="row justify-content-center m-0" v-if="videoReady">
				<div id="full-video-container" class="col-lg-10 position-relative m-0">
					<div class="inner-vid-conteiner m-0 w-100">
						<div class="inner-vid-wrap m-0 w-100">
							<div class="vid-wrapper w-100 h-100 position-relative">

								<!-- Primo video -->
								<transition name="fade">
									<video
										ref="guchema1"
										v-show="(step == 2)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[0].videoH"
										:width="videosData[0].videoW"
										loop
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[0].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Secondo video -->
								<transition name="fade">
									<video
										ref="guchema2"
										v-show="(step == 3)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[1].videoH"
										:width="videosData[1].videoW"
										loop
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[1].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Terzo video -->
								<transition name="fade">
									<video
										ref="guchema3"
										v-show="(step == 4)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[2].videoH"
										:width="videosData[2].videoW"
										loop
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[2].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Step 1 - Intro -->
								<div class="video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 1">

									<transition name="fade">
										<div id="btn-container" class="button-container text-center black-game-container">
											<div class="row px-4 h-100 align-items-center">
												<div class="col-md-12 border-default-black bg-white text-center" :class="{'d-none':  !(step == 1)}">
													<p class="ultra-bold text-size-box-1 mb-0" style="padding: 2%">
														In Italia la <span class="text-acid-green">pubblicità delle sigarette</span> e di ogni prodotto del tabacco è vietata per legge.<br>
														Eppure, a volte, <span class="text-acid-green">i divieti vengono aggirati</span><br>
														in modo subdolo.
													</p>
												</div>

												<div class="col-12" :class="{'d-none': !(step == 1)}" style="margin-top: 2%">
													<p class="text-acid-green ultra-bold text-center text-size-box-8">
														In ogni scenario, trova le 3 pubblicità occulte o le promozioni non esplicite!
													</p>
												</div>

												<div class="col-12 text-center" style="margin-top: 2%;">
													<button class="btn btn-acid-green approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep"><span class="va-m px-3 ultra-bold">{{btnText}}</span></button>
												</div>
											</div>
										</div>
									</transition>

								</div>

								<!-- Step 2 - Primo video -->
								<div class="video-end-container" v-if="step == 2">
									<div class="pointers-container position-relative d-flex w-100 h-100">

										<!-- Clickable Area -->
										<div class="points point-1 position-absolute text-white" @click.prevent="showPopUp1(3)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-2 position-absolute text-white" @click.prevent="showPopUp1(2)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-3 position-absolute text-white" @click.prevent="showPopUp1(1)">
											<span v-html="'&nbsp;'"></span>
										</div>

										<!-- PopUPs -->
										<transition name="fade">
											<div class="popup-container d-flex align-items-center justify-content-center w-100 h-100" v-if="popShow">

												<!-- PopUp 3 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="primoVideo.pop3.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp1(3)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">#SMOKECHALLENGE: CHE MALE C’È?</h2>
													<p class="text-size-box-3 mb-0">
														Le <strong>challenge</strong>, molto comuni sui social media più usati tra i giovani, vengono lanciate per promuovere indirettamente il fumo o lo svapo.<br>
														Alcuni <strong>hashtag</strong> sono promossi e ripresi dai ragazzi più giovani, che diventano <strong>testimonial inconsapevoli del fumo</strong>. Per esempio,
														<strong>hashtag</strong> come <strong>#smokechallenge</strong> invitano a fare giochi con le nuvole di svapo, a volte usando filtri divertenti:
														in questo modo il fumo viene reso più familiare, <strong>percepito come un gioco</strong> e non come un pericolo.
													</p>
												</div>

												<!-- PopUp 2 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="primoVideo.pop2.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp1(2)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">IN BELLA VISTA, SOTTO FALSO NOME</h2>
													<p class="text-size-box-3 mb-0">
														L’industria del tabacco è sempre stata attratta dal mondo dello sport e della sponsorizzazione sportiva.<br>
														<strong>Oggi le pubblicità esplicite sono vietate</strong>, ma si usano stratagemmi differenti. Ad esempio, si pubblicizzano siti apparentemente non legati al tabacco,
														al cui interno si trovano però informazioni sul <strong>tabacco riscaldato</strong>, che viene descritto come innovativo e all’avanguardia, sminuendone la pericolosità.
														Il <strong>merchandising</strong> è un’altra strategia: si vendono prodotti di marchi noti (legali) nei quali sono inseriti rimandi a pubblicità nascoste.
													</p>
												</div>

												<!-- PopUp 1 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="primoVideo.pop1.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp1(1)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">INSTASVAPO: SEMBRA NATURALE MA NON LO È</h2>
													<p class="text-size-box-3 mb-0">
														Gli adolescenti sono un <strong>obiettivo primario</strong> per l’industria del tabacco e dello svapo. Spesso i <strong>messaggi pubblicitari occulti</strong> sono rivolti specificamente <strong>ai più giovani</strong>,
														perché cominciare a fumare in età giovanile significa “creare” un consumatore per tutta la vita.<br>
														I messaggi pubblicitari sul fumo possono essere veicolati dagli <strong><i>influencer</i></strong> sui social media, con foto, video e dirette che <strong>appaiano “naturali”</strong> e non promozionali.
														In realtà gli <strong>influencer sono pagati per farsi ritrarre mentre fumano o svapano</strong>.
													</p>
												</div>

											</div>
										</transition>

										<div id="btn-go" class="text-center position-absolute" v-if="primoVideo.pop1.val && primoVideo.pop2.val && primoVideo.pop3.val">
											<button class="btn btn-acid-green approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
										</div>

									</div>
								</div>

								<!-- Step 3 - Secondo video -->
								<div class="video-end-container" v-if="step == 3">
									<div class="pointers-container position-relative d-flex w-100 h-100">

										<!-- Clickable Area -->
										<div class="points point-4 position-absolute text-white" @click.prevent="showPopUp2(3)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-5 position-absolute text-white" @click.prevent="showPopUp2(2)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-6 position-absolute text-white" @click.prevent="showPopUp2(1)">
											<span v-html="'&nbsp;'"></span>
										</div>

										<!-- PopUPs -->
										<transition name="fade">
											<div class="popup-container d-flex align-items-center justify-content-center w-100 h-100" v-if="popShow1">

												<!-- PopUp 3 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="secondoVideo.pop3.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp2(3)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">È QUI LA FESTA?</h2>
													<p class="text-size-box-3 mb-0">
														La promozione del tabacco è vietata, così come la sponsorizzazione. Tuttavia in alcuni casi vengono creati <strong>party e feste dedicati ai più giovani</strong>, nei quali si promettono eventi “eccitanti e divertenti”.<br>
														All’interno di questi appuntamenti possono esserci dei <strong>momenti di promozione occulta o illecita del tabacco</strong>, con l’intento di associare il fumo all’idea di libertà, divertimento e trasgressione.
													</p>
												</div>

												<!-- PopUp 2 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="secondoVideo.pop2.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp2(2)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">DEDICATO ALLE DONNE</h2>
													<p class="text-size-box-3 mb-0">
														Un bersaglio molto importante per le pubblicità del tabacco e dello svapo sono le <strong>ragazze</strong>, alcuni messaggi sono diretti proprio a loro.<br>
														Per promuovere le <strong>e-cig</strong> (sigarette elettroniche) si usano vecchi stratagemmi, già usati per sigarette classiche: si associa lo svapo a immagini colorate,
														<strong>profumi e foto di giovani donne sensuali e disinibite</strong>. In questo modo le sigarette elettroniche suggeriscono alle ragazze la falsa idea di <strong>libertà, profumo, sicurezza e bellezza</strong>.
													</p>
												</div>

												<!-- PopUp 1 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="secondoVideo.pop1.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp2(1)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">UN PERICOLO NORMALIZZATO</h2>
													<p class="text-size-box-3 mb-0">
														Alcune <strong>serie televisive</strong>, in streaming e non, pubblicizzano tabacco e fumo in modo occulto.<br>
														Spesso gli <strong>attori</strong> vengono ripresi <strong>mentre fumano</strong>, usano sigarette elettroniche oppure riscaldatori del tabacco. Queste riprese, inserite in momenti di vita quotidiana,
														<strong>fanno percepire il fumo come normale</strong> e socialmente accettato. Inoltre, possono trasmettere un <strong>falso senso di sicurezza</strong> in chi guarda.
													</p>
												</div>

											</div>
										</transition>


										<div id="btn-go" class="text-center position-absolute" v-if="secondoVideo.pop1.val && secondoVideo.pop2.val && secondoVideo.pop3.val">
											<button class="btn btn-acid-green approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
										</div>

									</div>
								</div>

								<!-- Step 4 - Terzo video -->
								<div class="video-end-container" v-if="step == 4">
									<div class="pointers-container position-relative d-flex w-100 h-100">

										<!-- Clickable Area -->
										<div class="points point-7 position-absolute text-white" @click.prevent="showPopUp3(3)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-8 position-absolute text-white" @click.prevent="showPopUp3(2)">
											<span v-html="'&nbsp;'"></span>
										</div>
										<div class="points point-9 position-absolute text-white" @click.prevent="showPopUp3(1)">
											<span v-html="'&nbsp;'"></span>
										</div>

										<!-- PopUPs -->
										<transition name="fade">
											<div class="popup-container d-flex align-items-center justify-content-center w-100 h-100" v-if="popShow1">

												<!-- PopUp 3 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="terzoVideo.pop3.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp3(3)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">QUANDO IL GADGET DÀ DIPENDENZA</h2>
													<p class="text-size-box-3 mb-0">
														La legge non lo permette ma è possibile trovare eventi nei quali vengono distribuiti pacchetti di sigarette <strong>promozionali</strong>,
														oppure altri <strong>prodotti alla nicotina</strong> come i <strong>“sacchetti”</strong>.<br>
														Questi prodotti sono senza tabacco (quindi le norme non ne impediscono la promozione), ma contengono <strong>alti livelli di nicotina</strong>, una sostanza che dà una <strong>fortissima dipendenza</strong> e
														può spingere verso le sigarette vere e proprie.
													</p>
												</div>

												<!-- PopUp 2 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="terzoVideo.pop2.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp3(2)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">SEMBRA QUASI UN DÉJÀ VU</h2>
													<p class="text-size-box-3 mb-0">
														Sì, non si possono promuovere sigarette e tabacco ma a volte è sufficiente ricordare <strong>il nome e il logo di un prodotto per far pensare al fumo!</strong><br>
														Un esempio? Nei locali può capitare che le <strong>foto</strong> della serata siano effettuate con alle spalle un <strong>backdrop</strong> (uno sfondo) che richiama il <strong>logo di noti marchi del tabacco riscaldato</strong>.
													</p>
												</div>

												<!-- PopUp 1 -->
												<div id="popUp" class="border-default-black bg-white text-left position-relative" v-if="terzoVideo.pop1.show">
													<div class="close-icon">
														<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp3(1)">
													</div>
													<h2 class="text-acid-green mt-1 text-size-box-3 ultra-bold">UN LOCALE ‘AMICO DEL FUMO’</h2>
													<p class="text-size-box-3 mb-0">
														Non si possono promuovere le sigarette e il tabacco? Vero, ma esistono alcune zone grigie. Per esempio, è possibile <strong>“brandizzare”</strong> i locali con specifici marchi legati al fumo.<br>
														Questo avviene in particolare per i <strong>prodotti a tabacco riscaldato</strong>: spesso vengono <strong>sponsorizzati con apposite targhe</strong>,
														a volte affisse sulla facciata di ristoranti e bar, per far capire che si tratta di locali <strong>smoke-friendly</strong>.
													</p>
												</div>

											</div>
										</transition>


										<div id="btn-go" class="text-center position-absolute" v-if="terzoVideo.pop1.val && terzoVideo.pop2.val && terzoVideo.pop3.val">
											<button class="btn btn-acid-green approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
										</div>

									</div>
								</div>

								<div class="d-flex w-100 h-100 align-items-center justify-content-center video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 5">

									<transition name="fade">
										<div id="btn-container" class="button-container text-center black-game-container">
											<div class="row px-4 h-100 align-items-center">
												<div class="col-md-12 border-default-black bg-white text-center" style="padding: 3%;">
													<h2 class="text-size-box-8 ultra-bold text-acid-green">Complimenti!</h2>
													<p class="ultra-bold text-size-box-2 mb-0">
														Ora conosci alcune delle tecniche nascoste<br>
														per promuovere i prodotti del fumo:<br>
														non farti fregare!
													</p>
												</div>

												<div id="btn-go" class="text-center col-12 align-self-end">
													<button class="btn btn-acid-green approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
												</div>

											</div>
										</div>
									</transition>

								</div>

								<transition name="fade">
									<div class="d-flex w-100 h-100 align-items-center justify-content-center video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 6">
										<div class="row px-4 h-100 align-items-center">

											<div class="col-12 align-self-end">
												<p class="text-acid-green ultra-bold text-center text-size-box-10 end mb-0 full-text">
													Adesso scopri le 5 ragioni<br>
													per cui si cerca il fumo<br>
													pur sapendo che fa male.
												</p>
											</div>

											<div class="col-12 text-center">
												<a :href="linkUrl.back" class="btn btn-acid-green approf rounded-pill mr-3 go-next-back mb-2"><span class="va-m">TORNA INDIETRO</span></a>
												<a :href="linkUrl.next" class="btn btn-acid-green approf rounded-pill go-next-back mb-2"><span class="va-m">VAI AL PROSSIMO PERCORSO</span></a>
											</div>

										</div>
									</div>
								</transition>

							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="mobile-icon-container" class="container-fluid" v-else>
			<div class="row">
				<div class="col-12">
					<div class="img-rotate position-relative" style="height: 100vh;">
						<img id="phone-gif" :src="rotateScreenUrl" alt="Rotate phone">
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
const jQuery = window.jQuery
import { urlBase, themeDir, urlHost } from '../../variables.js'
import axios from 'axios'

export default {
	name: 'GuardaCheMarketing',

	data() {
		return {
			ajaxObj: window.ajax_object,
			step: 0,
			videoArray: ['/videos/544786633', '/videos/544786571', '/videos/544786443'],
			videosData: [],
			videoReady: false,
			resolution: {
				max: (window.screen.availWidth > window.screen.availHeight) ? window.screen.availWidth : window.screen.availHeight
			},
			isMobile: false,
			isPortrait: false,
			themeUrl: '',
			coverUrl: '',
			btnText: 'VAI',
			closeIcon: '',
			popShow: false,
			popShow1: false,
			popUpIsOpen: false,
			primoVideo: {
				pop1: {
					val:0,
					show: false
				},
				pop2: {
					val:0,
					show: false
				},
				pop3: {
					val:0,
					show: false
				}
			},
			secondoVideo: {
				pop1: {
					val:0,
					show: false
				},
				pop2: {
					val:0,
					show: false
				},
				pop3: {
					val:0,
					show: false
				}
			},
			terzoVideo: {
				pop1: {
					val:0,
					show: false
				},
				pop2: {
					val:0,
					show: false
				},
				pop3: {
					val:0,
					show: false
				}
			},
			linkUrl:{
				back: '',
				next: ''
			}
		}
	},

	methods: {
		isMobileFn() {
			this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		},
		isPortraitFn() {
			this.isPortrait = (window.innerHeight > window.innerWidth)
		},

		nextStep() {
			this.step = this.step + 1

			if(this.step == 2) {
				this.$refs.guchema1.play()
			} else if(this.step == 3) {
				this.$refs.guchema2.play()
			} else if(this.step == 4) {
				this.$refs.guchema3.play()
			}
		},

		showPopUp1(popNo) {
			if(!this.popUpIsOpen) {
				if(popNo == 3) {
					this.primoVideo.pop3.show = true
				} else if (popNo == 2) {
					this.primoVideo.pop2.show = true
				} else if (popNo == 1) {
					this.primoVideo.pop1.show = true
				}
				this.popShow = true
				this.popUpIsOpen = true
			}
		},

		showPopUp2(popNo) {
			if(!this.popUpIsOpen) {
				if(popNo == 3) {
					this.secondoVideo.pop3.show = true
				} else if (popNo == 2) {
					this.secondoVideo.pop2.show = true
				} else if (popNo == 1) {
					this.secondoVideo.pop1.show = true
				}
				this.popShow1 = true
				this.popUpIsOpen = true
			}
		},

		showPopUp3(popNo) {
			if(!this.popUpIsOpen) {
				if(popNo == 3) {
					this.terzoVideo.pop3.show = true
				} else if (popNo == 2) {
					this.terzoVideo.pop2.show = true
				} else if (popNo == 1) {
					this.terzoVideo.pop1.show = true
				}
				this.popShow1 = true
				this.popUpIsOpen = true
			}
		},

		closePopUp1(popNo) {
			this.popShow = false
			this.popUpIsOpen = false
			if(popNo == 3) {
				this.primoVideo.pop3.show = false
				this.primoVideo.pop3.val = 1
			} else if (popNo == 2) {
				this.primoVideo.pop2.show = false
				this.primoVideo.pop2.val = 1
			} else if (popNo == 1) {
				this.primoVideo.pop1.show = false
				this.primoVideo.pop1.val = 1
			}
		},

		closePopUp2(popNo) {
			this.popShow1 = false
			this.popUpIsOpen = false
			if(popNo == 3) {
				this.secondoVideo.pop3.show = false
				this.secondoVideo.pop3.val = 1
			} else if (popNo == 2) {
				this.secondoVideo.pop2.show = false
				this.secondoVideo.pop2.val = 1
			} else if (popNo == 1) {
				this.secondoVideo.pop1.show = false
				this.secondoVideo.pop1.val = 1
			}
		},

		closePopUp3(popNo) {
			this.popShow1 = false
			this.popUpIsOpen = false
			if(popNo == 3) {
				this.terzoVideo.pop3.show = false
				this.terzoVideo.pop3.val = 1
			} else if (popNo == 2) {
				this.terzoVideo.pop2.show = false
				this.terzoVideo.pop2.val = 1
			} else if (popNo == 1) {
				this.terzoVideo.pop1.show = false
				this.terzoVideo.pop1.val = 1
			}
		},

		calculateVideoWidth() {
			let screen_h = screen.availHeight
			let screen_w = ((screen_h * 16) / 9) - 20

			jQuery('#full-video-container').css('max-width', screen_w + 'px')
		},
		handleOrientationChange() {
			this.isMobileFn()
			this.isPortraitFn()
			if(this.isPortrait) {
				this.isMobile = true
				this.isPortrait = false
				this.removeEvent()
			}
		},
		removeEvent() {
			window.removeEventListener("orientationchange", this.handleOrientationChange, true)
		},

		getVimeoVideosData() {
			let _self = this

			for (let i = 0; i < this.videoArray.length; i++) {
				let formData = new FormData()
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('action', 'nl_vimeo_video_info')
				formData.append('video_uri', this.videoArray[i])

				axios.post( this.ajaxObj.ajax_url, formData)
					.then(function(response){
						// console.log(response.data.body.files)
						_self.checkResolution(response.data.body.files, i)
					})
			}
		},

		checkResolution(vimeoFiles, index) {
			let _self = this
			let lastVal = 0
			let rightObj = {};

			for (let urlData of vimeoFiles) {
				let videoResMaxVal = urlData.height > urlData.width ? urlData.height : urlData.width

				if(Math.abs(this.resolution.max - videoResMaxVal) <= Math.abs(this.resolution.max - lastVal)) {
					rightObj = urlData
					lastVal = videoResMaxVal
					// console.log(rightObj)
				}
			}

			let tmpArray = this.videosData
			this.videosData = []
			tmpArray[index] = {
				videoSrc: rightObj.link,
				videoH: rightObj.height,
				videoW: rightObj.width
			}
			this.videosData = tmpArray
			if(this.videosData.length == 3) setTimeout(function(){ _self.videoReady = true; }, 100)
		}
	},

	mounted() {
		let _self = this
		jQuery('#wrapper-navbar, #wrapper-footer').addClass('d-none')
		this.themeUrl = urlBase + themeDir
		this.isMobileFn()
		this.isPortraitFn()

		if(this.isMobile && this.isPortrait) {
			this.rotateScreenUrl = this.themeUrl + 'img/rotate_screen.gif'
			window.addEventListener("orientationchange", this.handleOrientationChange, true)
		}

		this.coverUrl = this.themeUrl + 'img/covers/Guarda_che_marketing_Cover_Back.jpg'
		this.closeIcon = this.themeUrl + 'img/x.svg'
		this.step = 1

		jQuery(window).resize(function(){
			_self.calculateVideoWidth()
		})

		this.getVimeoVideosData()

		this.linkUrl.back = urlBase + urlHost + 'guarda-che-marketing'
		this.linkUrl.next = urlBase + urlHost +'5-ragioni-per'
	},
	updated() {
		this.calculateVideoWidth()
	}
}
</script>

<style scoped>
	.go-next-back {
		padding-left: 2.8% !important;
		padding-right: 2.8% !important;
		padding-bottom: 0.5% !important;
		padding-top: 0.5% !important;

		margin: 1.2%;
	}
	@media (max-width: 991.98px) {
		.text-size-box-10.end {
			font-size: 2.5rem;
		}
	}
	@media (max-width: 767.98px) {
		.full-text {
			font-size: 1.2rem;;
		}
		.text-size-box-10.end {
			font-size: 1.8rem;
		}
	}
	@media (min-width: 992px) {
		.go-next-back {font-size: 1.1rem !important;}
	}


	video {
		width: 100%;
		height: auto;
	}
	.inner-vid-conteiner {
		width: 100%;
		position: absolute;
		top:50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.inner-vid-wrap {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}
	#btn-container {
		position: absolute;
		bottom: 8%;
		top: 5%;
		left: 50%;
		transform: translateX(-50%);
	}

	.btn.game {
		border-width: 4px;
		font-weight: 800;
		font-size: 1.5vw;
	}
	@media (max-width: 991.98px) {
		.btn {
			padding: .344rem 3rem;
		}
		.btn.game {
			font-size: .9rem;
		}
		#popUp p {
			font-size: 1rem !important;
		}
	}
	@media (max-width: 767.98px) {
		#popUp p {
			font-size: 0.94rem !important;
		}
		h2.text-acid-green.text-size-box-3 {
			font-size: 1.1rem;
		}
	}
	.video-end-container {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}

	.fade-enter-active/*, .fade-leave-active*/ {
		transition: opacity 0.9s;
	}
	.fade-enter/*, .fade-leave-to */ {
		opacity: 0;
	}

	#phone-gif {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);;
	}
	#full-video-container {height: 100vh;}

	/** absolute points ****************/
	.points {
		cursor: pointer;
		/*border: 3px solid #000;*/
	}
	/** Schermata 1 *******************/
	.point-1 {
		height: 39%;
		width: 14%;
		top: 49%;
		left: 17.3%;
	}
	.point-2 {
		height: 20%;
		width: 14%;
		top: 43%;
		left: 58%;
	}
	.point-3 {
		height: 34%;
		width: 18%;
		top: 45%;
		left: 73.5%;
	}
	/** Schermata 2 ******************/
	.point-4 {
		height: 37%;
		width: 13.5%;
		top: 62%;
		left: 7.5%;
	}
	.point-5 {
		height: 25%;
		width: 18%;
		top: 61.5%;
		left: 44%;
	}
	.point-6 {
		height: 35%;
		width: 21.5%;
		top: 14%;
		left: 77.5%;
	}
	/** Schermata 3 ******************/
	.point-7 {
		height: 55%;
		width: 23%;
		top: 40%;
		left: 2%;
	}
	.point-8 {
		height: 35%;
		width: 22%;
		top: 40%;
		left: 35%;
	}
	.point-9 {
		height: 65%;
		width: 28%;
		top: 14%;
		left: 65%;
	}
	/** PopUps */
	#popUp {
		max-width: 80%;
		padding: 3.4%;
	}
	.close-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 6%;
		height: auto;
		transition: all .2s ease-in-out;
	}
	.close-icon:hover {opacity: 0.5;}
	#btn-go {
		left: 50%;
		bottom: 9%;
		transform: translateX(-50%);
	}
	.popup-container {
		background-color: rgba(0,0,0,.8);
		z-index: 10;
	}
</style>
